module.exports = __webpack_public_path__ + "static/media/56.ca1b2922.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/poinkos/56.jpg
// module id = 589
// module chunks = 0